export default "__VITE_ASSET__DGvViA8Z__"